<template>
  <div class="navbar">
    <el-menu :default-active="activeMenu" mode="horizontal">
      <sidebar-item
        v-for="route in routes"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>
import { GetMenu } from '@/api/user'
import SidebarItem from './SidebarItem'
import { getPermissions } from '@/api/role'

export default {
  components: { SidebarItem },
  data () {
    return {
      routes: []
    }
  },
  created () {
    let permission = this.$store.state.home.permission
    let list = []
    permission.map(menu => {
      menu.permissions.map(per => {
        if (per.annotation === '查看' && per.status === 1) {
          let menus = menu.menuName.split('-')
          list.push(menus[0])
        }
      })
    })
    this.createMenu(list)
  },
  methods: {
    createMenu (list) {
      const routes = this.$router.options.routes
      const _routes = []
      // if (process.env.ENV = "development") {
      //   this.routes = routes
      // } else {
      routes.forEach(element => {
        const hidden = element['hidden']
        const title = element['meta'] && element['meta']['title']
        if (hidden || list.indexOf(title) >= 0) {
          _routes.push(element)
        }
      })
      this.routes = _routes
      // }
    },
  },
  computed: {
    // routes() {
    //   return this.$router.options.routes
    // },
    activeMenu () {
      const route = this.$route
      let { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      // 二级目录 返回 一级目录
      let list = path.split('/')
      if (list.length > 2) {
        path = '/' + list[1]
      }
      return path
    },
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.navbar {
  .el-menu {
    background-color: transparent;
    &.el-menu--horizontal {
      border-bottom: none;
    }
  }
}
</style>